<template>
  <!-- <li :class="{ highlight, editing }" class="variant" @click="getPreview()" @paste="handlePaste"> -->
  <li
    :class="{
      highlight,
      editing,
      'active-dropzone-variant': activeDropzone && draggingVariant,
      hide: isDragging == variant.id,
      'dragging-variant': isDragging == variant.id,

      'drop-over': activeDropzone == draggingIndex > variantIndex,
      'drop-under': activeDropzone == draggingIndex < variantIndex
    }"
    :style="{
      'cursor: grabbing;': isDragging == variant.id
    }"
    class="variant"
    ref="variant"
    :draggable="activeDragHandle"
    @click="getPreview()"
    @dragstart="onDragVariant($event, variant, $refs.variant)"
    @drop="$emit('onDrop', $event, variant), (activeDropzone = false)"
    @dragover.prevent="activeDropzone = true"
    @dragenter.prevent="activeDropzone = true"
    @dragleave.prevent="activeDropzone = false"
    @dragend="$emit('dragEnd'), (activeDropzone = false)"
  >
    <span class="d-flex variant-editor-container " :class="highlightedVariant == true ? 'searched-variant' : ''">
      <variant-editor
        v-if="!showRawHTML && ready"
        class="flex-grow-1"
        :class="{ translating: translating }"
        :variant="variant.text"
        :variantObject="variant"
        :editing="editing"
        :higlightOrEditing="higlightOrEditing"
        :draggingVariant="activeDragHandle"
        @variant-updated="(v) => (variant.text = v)"
        @remove="(options) => $emit('remove', options)"
        @add-below="$emit('add')"
        @focus="$store.commit('setVariantBeingEdited', variant)"
      />
      <textarea
        class="raw-editor flex-grow-1"
        v-if="showRawHTML"
        name="textarea"
        ref="textarea"
        contenteditable
        v-model="variant.text"
        @input="autoResizeTextarea"
      ></textarea>
      <span class="actions" v-if="!$store.state.showingTemplateBackupInPreview">
        <div class="standard-actions">
          <div
            v-if="!isDemo"
            class="variant-action drag-grip-variant"
            :class="{ 'is-dragging': isDragging == variant.id }"
            @mousedown="activeDragHandle = true"
            @mouseleave="activeDragHandle = false"
          >
            <i class="fa-light fa-grip-dots-vertical"></i>
          </div>
          <div
            class="variant-action"
            @click="onRemove"
            :tooltip="showTooltips ? $t('variant.delete-variant') : ''"
            tooltip-placement="left"
          >
            <i class="fa-light fa-trash"></i>
          </div>
          <div
            class="variant-action"
            @click.stop="
              handleAction($event, 'convertVariant', () => {
                convertToSentence($event);
              })
            "
            :tooltip="showTooltips ? $t('variant.convert-variant') : ''"
            tooltip-placement="left"
          >
            <i class="fa-light fa-level-up-alt" style="transform: rotate(90deg)"></i>
          </div>
          <div
            v-if="!isDemo"
            class="variant-action"
            :tooltip="showTooltips ? $t('duplicate-below') : ''"
            tooltip-placement="left"
            @click.stop="cloneBelow()"
          >
            <i class="fa-light fa-clone"></i>
          </div>
        </div>
        <br />
        <div class="ai-variant-actions">
          <dropdown>
            <button slot="toggle" class="btn-toggle ai-dropdown" conditionalToggle="true">
              <span>
                <i class="fa-light fa-pen"></i>
              </span>
              
            </button>
            <div class="ai-actions">
              <span class="ai-description">AI assistance</span>
              <div
                class="dropdown-item"
                @mouseover="getPosition('addvars'), (hovering = `addvars`)"
                @mouseleave="hovering = null"
                ref="addvars"
              >
                <div @click="addAiVariantsToList()" class="translation-action" :class="{ disabled: loadingAIVariants }">
                  <span>
                    {{ $t("ai-variant.rephrase") }}
                  </span>
                  <span class="text-muted text-xs">
                    {{ autoRephraseVariantAmount }}
                  </span>
                </div>
                <context-menu
                  class="submenu"
                  v-if="hovering == `addvars`"
                  :left="subMenuPos.x"
                  :top="subMenuPos.y"
                  ref="addvarscontext"
                >
                  <span class="ai-description">{{ $t("ai-variant.amount") }}</span>
                  <div
                    v-for="(amount, index) in aiVariantAmounts"
                    :key="index"
                    class="dropdown-item"
                    @click="addAiVariantsToList(amount)"
                    :class="{ 'current-selection': amount == autoRephraseVariantAmount, disabled: loadingAIVariants }"
                  >
                    {{ amount }}
                  </div>
                </context-menu>
              </div>

              <div
                v-if="!isDemo"
                class="dropdown-item"
                @mouseover="getPosition('translate'), (hovering = `translate`)"
                @mouseleave="hovering = null"
                ref="translate"
              >
                <div @click="translateVariant()" class="translation-action">
                  <span>
                    {{ $t("ai-translate.translate") }}
                  </span>
                  <span class="text-muted text-xs">
                    {{ $store.state.aiTranslationLanguage | capitalize }}
                  </span>
                </div>

                <context-menu
                  class="submenu"
                  v-if="hovering == `translate`"
                  :left="subMenuPos.x"
                  :top="subMenuPos.y"
                  ref="translatecontext"
                >
                  <span class="ai-description">{{ $t("ai-translate.translate-to") }}</span>
                  <div @click.stop="translateVariant()" class="dropdown-item">
                    {{ $store.state.aiTranslationLanguage | capitalize }}
                  </div>
                  <div @click.stop="onSelectTranslationLanguage" class="dropdown-item">
                    {{ $t("ai-translate.change-lang") }}
                  </div>
                </context-menu>
              </div>
            </div>
          </dropdown>
        </div>
        <div
          class="variant-action undo-btn"
          v-if="variantDidTranslate"
          @click="undoTranslation()"
          :tooltip="$t('undo-translation')"
          tooltip-placement="left"
        >
          <span>
            <i class="fa-light fa-undo"></i>
          </span>
        </div>
      </span>
    </span>
  </li>
</template>
<script>
import ContextMenu from "@/components/ContextMenu";
import AiLanguageModal from "@/components/modals/AiLanguageModal";
import EventBus from "@/assets/js/eventBus.js";
import VariantEditor from "@/components/VariantEditor";
import { editorMixin } from "@/assets/js/editorMixin.js";
export default {
  props: {
    // editorIsActive: {
    // 	type: Boolean,
    // 	default: false
    // },
    variant: {
      type: Object,
      required: true
    },
    // canConvert: {
    isDragging: [Number, String],
    // 	type: Boolean
    // },
    showRawHTML: {
      type: Boolean,
      default: false
    },
    draggingIndex: Number,
    variantIndex: Number
  },
  mixins: [editorMixin],
  data() {
    return {
      ready: true,
      translating: false,
      highlightedVariant: false,
      activeDragHandle: false,
      activeDropzone: false,
      selectedAmount: this.$store.state.autoRephraseVariantAmount,
      hovering: null,
      subMenuPos: {
        x: null,
        y: null
      },
      oldVariantText: "",
      variantDidTranslate: false
    };
  },
  computed: {
    highlight() {
      return (
        this.variant.path && this.$store.state.sentenceBeingEdited.path.toString() === this.variant.path.toString()
      );
    },
    editing() {
      return this.variant.editorIsActive;
    },
    higlightOrEditing() {
      if (this.editing == true || this.highlight == true) return true;
      else return false;
    },
    showTooltips() {
      return this.$store.state.showTooltips;
    },
    draggingVariant() {
      return this.$store.state.draggedVariant ? true : false;
    },
    testDragging() {
      return this.$store.state.draggedVariant ? true : false;
    },
    isDemo() {
      return this.$store.state.editorIsDemoVersion;
    },
    autoRephraseVariantAmount() {
      return this.$store.state.autoRephraseVariantAmount;
    },
    loadingAIVariants() {
      return this.$store.state.loadingAIVariants;
    },
    aiVariantAmounts() {
      return this.isDemo ? [1, 2] : [1, 2, 3, 4, 5];
    }
  },
  methods: {
    onSelectTranslationLanguage() {
      console.log("change language");
      this.$modal.show(
        AiLanguageModal,
        {},
        {
          height: "auto",
          width: 350
        }
      );
    },
    getPosition(element) {
      const el = this.$refs[element];
      const rect = el.getBoundingClientRect();
      this.$set(this.subMenuPos, "x", rect.right);
      this.$set(this.subMenuPos, "y", rect.y);
    },

    convertToSentence(event) {
      this.$emit("convert-to-sentence", { selectedIndex: this.selectedIndex, selectedLength: this.selectedLength });
    },

    onRemove() {
      this.$emit("onRemove");
    },

    getPreview() {
      return this.$store
        .dispatch("getSentencePreview", this.variant.text)
        .then((preview) => this.$store.commit("setSentenceEditorPreview", preview));
    },

    highlightVariant(id) {
      if (this.variant.id == id) {
        this.highlightedVariant = true;
        setTimeout(() => {
          this.highlightedVariant = false;
        }, 2000);
      }
    },

    autoResizeTextarea(event) {
      let area = event ? event.target : this.$refs.textarea;
      area.style.overflow = "hidden";
      area.style.height = area.scrollHeight + "px";
    },

    onDragVariant(event, variant) {
      EventBus.$emit("trigger-ghost-element", this.$refs.variant.clientHeight);
      this.$emit("startDrag", event, variant);
    },
    cloneBelow() {
      this.$emit("clone-below");
    },

    addAiVariantsToList(amount = undefined) {
      if (amount) this.$store.commit("setAutoRephraseVariantAmount", amount);
      this.$emit("ai-rephrase-variant");
    },

    undoTranslation() {
      this.variant.text = this.oldVariantText;
      this.variantDidTranslate = false;
      this.rerender();
    },

    translateVariant() {
      this.translating = true;
      const data = {
        variantText: this.variant.text,
        translationLanguage: this.$store.state.aiTranslationLanguage
      };

      this.$store
        .dispatch("translateAivariant", data)
        .then((res) => {
          console.log(res);
          if (!this.variantDidTranslate) this.oldVariantText = new String(this.variant.text);
          this.variant.text = res;
          this.rerender();
          this.variantDidTranslate = true;
        })
        .finally(() => {
          this.translating = false;
        });
    },

    rerender() {
      this.ready = false;
      this.$nextTick(() => {
        this.ready = true;
      });
    }
  },
  watch: {
    "variant.text"(variant) {
      // console.log('updated variant: ' + variant)
      EventBus.$emit("templateChange");
      this.getPreview();
    },
    editing: {
      immediate: true,
      handler(activeState, previousActiveState) {
        if (activeState) {
          console.log("is editing: " + this.variant.text);
        } else {
          if (previousActiveState == true) console.log("stopped editing: " + this.variant.text);
        }
      }
    },

    // this is not working yet
    showRawHTML: {
      immediate: true,
      handler: function() {
        if (this.showRawHTML == true) {
          this.$nextTick(() => {
            this.$refs.textarea.style.overflow = "hidden";
            this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + "px";
          });
        }
      }
    }
  },
  mounted() {
    EventBus.$on("highlightVariantById", this.highlightVariant);
  },
  filters: {},
  components: {
    VariantEditor,
    ContextMenu
  }
};
</script>

<style lang="less">
.ai-actions {
  .dropdown-item {
    color: #8a2be2;
  }
  .translation-action {
    display: flex;
    flex-direction: column;
  }
  .submenu {
    border-radius: 10px;
    background: #fff;
    transform: translate(-8px, -14px);
  }
}
.ai-dropdown {
  border-radius: 20px;
  padding: 0 4px 0 4px;
  border: none;
  height: 24px;
  color: #fff; //v2
  background: #b57bff; //v2
  &:hover,
  &:focus {
    background: #8a2be2; // v2
  }
}
.hide {
  opacity: 0.1;
  list-style-type: none;
  // display: none;
}

.translating {
  filter: blur(2px);
}

.dragging-variant {
  .variant-editor-container {
    height: 24px;
    p {
      text-overflow: ellipsis;
      width: 100px;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.active-dropzone-variant.drop-over .variant-editor-container {
  position: relative;
  &::before {
    width: 100%;
    content: "";
    position: absolute;
    top: 0;
    height: 24px;
    background-color: rgba(110, 117, 122, 0.123);
    border: thin dashed #8f979c;
  }
  // transition: .05s;
  padding-top: 26px;
}
.active-dropzone-variant.drop-under .variant-editor-container {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    height: 24px;
    background-color: rgba(110, 117, 122, 0.123);
    border: thin dashed #8f979c;
    width: 100%;
  }
  // transition: .05s;
  padding-bottom: 26px;
}
.variant {
  list-style: none;
  margin: 4px 0;
  border-radius: 13px 0 0 13px;
  color: var(--text-grey-primary);
  line-height: 24px;
  // padding-bottom: 10px;
  word-break: break-word;
  padding: 2px;
  padding-left: 6px;
  list-style-type: none;
  position: relative;
  &::before {
    position: absolute;
    left: -5px;
  }

  .actions {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    white-space: nowrap;
    visibility: hidden;
    padding: 0 8px;
    color: var(--background-white);

    .standard-actions {
      display: flex;
      flex-direction: row-reverse;
    }

    .variant-action {
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 24px;
      justify-content: center;
      &:hover {
        background-color: var(--charcoal);
        border-radius: 100%;
      }

      &.drag-grip-variant {
        padding: 0px 12px;
      }
    }
    .undo-btn {
      color: #fff;
      font-size: 12px;
    }

    .disabled {
      pointer-events: none;
      opacity: 0.4;
    }
    .ai-variant-actions {
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      margin-right: 8px;
      font-size: 10px;
      height: 24px;
      border-radius: 20px;

      .dropdown {
        .ai-description {
          padding: 0 8px;
          color: var(--charcoal-75);
        }
        .dropdown-item {
          display: flex;

          &.current-selection {
            color: #8a2be2;
            background: #892be215;
          }
        }
        .btn-toggle {
          border-radius: 200px;
          padding: 0 4px 0 4px;
          border: none;
          height: 24px;
          width: 24px;

          color: #fff; //v2
          background: #b57bff; //v2
        }
      }

      .dropdown .btn-toggle,
      .button-rephrase {
        &:hover,
        &:focus {
          background: #8a2be2; // v2
        }
      }
    }
  }

  &.highlight {
    // position: relative;
    // list-style-type: none;
    color: #fff;
    .editing-container {
      color: #fff;
    }
    &:before {
      content: "\2022";
      position: absolute;
      transform: scale(1.15);
      color: var(--orange-web);
      font-weight: bold;
      display: inline-block;
      width: 10px;
      margin-left: -10px;
    }
  }

  &:hover {
    background-color: #6e757a;
    .actions {
      visibility: visible;
    }
  }

  &.editing {
    background-color: #6e757a;
    color: white;
    .actions {
      visibility: visible;
    }
  }

  .searched-variant {
    color: #fff;
    // font-weight: 900;
    transition: 0.4s;
    &::before {
      content: "\2022";
      position: absolute;
      transform: scale(2);
      color: #fff;
      font-weight: bold;
      display: inline-block;
      margin-top: 1px;
      margin-left: -16px;
    }
  }
  .raw-editor {
    outline: none;
    background: none;
    resize: none;
    color: #fff;
    border: none;
    line-height: 24px;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    height: max-content;
  }
}

#app .ai-variant-rephrase button:focus {
  outline: none;
}
</style>
